module.exports = __webpack_public_path__ + "img/바카라.500fb3e9.png";